import { render, staticRenderFns } from "./EmulatorNavigationItem.vue?vue&type=template&id=44cb4737&scoped=true"
import script from "./EmulatorNavigationItem.vue?vue&type=script&lang=js"
export * from "./EmulatorNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./EmulatorNavigationItem.vue?vue&type=style&index=0&id=44cb4737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb4737",
  null
  
)

export default component.exports